class AdvancedSlider extends HTMLElement {
  constructor() {
    super();
    this.debounceTimer = null;
  }

  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    // Load Swiper if not already present
    if (typeof Swiper === 'undefined') {
      const script = document.createElement('script');
      script.src = '{{ "swiper.min.js" | asset_url }}'; // Liquid-compatible path
      script.onload = () => this.initializeMainSlider();
      document.head.appendChild(script);
    } else {
      this.initializeMainSlider();
    }
  }

  debounce(func, delay) {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(func, delay);
  }

 updateAllSliderHeights() {

  const sliders = this.querySelectorAll(".main-slider.slider--adapt-to-image");

  if (!sliders.length) {
    console.warn('No .main-slider.slider--adapt-to-image elements found');
  }

  sliders.forEach(slider => {
    const img = slider.querySelector(".swiper-slide:not(.swiper-slide-duplicate) img");
    
    if (!img) {
      return;
    }

    const setHeight = () => {
      const ratio = img.naturalHeight / img.naturalWidth;
      const width = slider.offsetWidth;
      const realHeight = ratio * width;
      slider.style.height = realHeight + "px";
    };

    if (img.complete) {
      setHeight();
    } else {
      img.addEventListener("load", () => {
        setHeight();
      }, { once: true });
    }

    window.addEventListener("resize", () => {
      setHeight();
    });
  });
}



 initializeMainSlider() {
  const sliderElement = this.querySelector(".main-slider");
  if (!sliderElement) return;

  const enableImageAdaptation = sliderElement.dataset.adaptToImage === "true";
  const enableAutoplay = sliderElement.dataset.enableAutoplay === "true";
  const autoplaySpeedSeconds = parseFloat(sliderElement.dataset.autoplaySpeed) || 3;
  const autoplaySpeedMilliseconds = autoplaySpeedSeconds * 1000;
  const sliderDirection = sliderElement.dataset.sliderDirection || "horizontal";
  const sliderLoop = sliderElement.dataset.sliderLoop === "true";
  const component = this;

  /* Los controles se buscan DENTRO del componente, no en el documento.
     Antes iban como selectores de cadena (".swiper-button-next", ".swiper-pagination"),
     que Swiper resuelve contra el documento: con dos secciones advanced-slider en la
     misma página —que es justo lo que había en la home hasta este rediseño— los dos
     Swipers se peleaban por los mismos nodos. */
  const nextEl = this.querySelector(".swiper-button-next");
  const prevEl = this.querySelector(".swiper-button-prev");
  const paginationEl = this.querySelector(".swiper-pagination");

  /* El modo hero pide bullets (los tres segmentos del Figma); el resto del theme
     sigue con la barra de progreso continua de siempre. */
  const paginationType = sliderElement.dataset.paginationType || "progressbar";

  /* Contador "1 / 3". Solo el número actual se actualiza: el total lo escribe Liquid,
     que ya sabe cuántos bloques hay. Si el nodo no está, esto no hace nada. */
  const counterCurrentEl = this.querySelector("[data-slider-counter-current]");
  const updateCounter = function (swiper) {
    if (!counterCurrentEl) return;
    /* realIndex y no activeIndex: con `loop: true` este bundle de Swiper MUEVE las
       diapositivas reales de sitio (`loopFix` hace prepend/append sobre los mismos
       nodos; no hay una sola llamada a cloneNode en swiper.min.js), así que
       activeIndex apunta a la posición en el DOM reordenado y no al bloque que
       escribió Liquid. realIndex sí. */
    counterCurrentEl.textContent = swiper.realIndex + 1;
  };

  /* El módulo a11y de Swiper viene `enabled: true` por defecto y en su init llama a
     `setAttribute("aria-label", ...)` sobre las flechas con sus cadenas en inglés
     ("Previous slide" / "Next slide"), pisando las que emite Liquid desde
     locales/es.json. Se le devuelven las del DOM para que Liquid siga siendo la única
     fuente. No se apaga el módulo: también pone `aria-controls`, que sí suma.

     La clave solo se añade si el nodo trae etiqueta —o sea, solo en modo hero—. NO
     vale pasar `undefined`: el `extend` de Swiper copia el valor tal cual aunque sea
     undefined (comprobado sobre assets/swiper.min.js), y el módulo acabaría
     escribiendo la cadena literal "undefined" en el aria-label del modo default. */
  const a11yMessages = {};
  const prevLabel = prevEl && prevEl.getAttribute("aria-label");
  const nextLabel = nextEl && nextEl.getAttribute("aria-label");
  if (prevLabel) a11yMessages.prevSlideMessage = prevLabel;
  if (nextLabel) a11yMessages.nextSlideMessage = nextLabel;

  const mainSliderOptions = {
    loop: sliderLoop,
    speed: 1000,
    parallax: true,
    direction: sliderDirection,
    grabCursor: true,
    watchSlidesProgress: true,
    autoplay: enableAutoplay
      ? { delay: autoplaySpeedMilliseconds, disableOnInteraction: false }
      : false,
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    pagination: {
      el: paginationEl,
      type: paginationType,
      clickable: paginationType === "bullets",
    },
    a11y: a11yMessages,
    on: {
      init: function () {
        updateCounter(this);

        if (!this.slides || !this.slides.length) return;

        const activeSlide = this.slides[this.activeIndex];
        if (!activeSlide) return;

        activeSlide.querySelectorAll(".title, .caption-box, .caption, .banner-buttons")
          .forEach(el => el?.classList.add("show"));

        if (this.autoplay && enableAutoplay) {
          this.autoplay.start();
        }

        if (enableImageAdaptation) {
          component.updateAllSliderHeights();
        }
      },
      slideChange: function () {
        updateCounter(this);
      },
      slideChangeTransitionEnd: function () {
        const activeSlide = this.slides[this.activeIndex];
        if (!activeSlide) return;

        this.el.querySelectorAll(".caption, .banner-buttons, .title, .caption-box")
          .forEach(el => el.classList.remove("show"));

        activeSlide.querySelectorAll(".title, .caption-box, .caption, .banner-buttons")
          .forEach(el => el?.classList.add("show"));
      },
      touchStart: function () {
        this.slides.forEach(slide => {
          slide.style.transition = "";
        });
      },
    },
  };

  new Swiper(sliderElement, mainSliderOptions);
}

}

customElements.define('advanced-slider', AdvancedSlider);